import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_BENEFIT_ITEMS_LIST, GET_BENEFIT_ITEMS_LIST_SUCCESS, GET_BENEFIT_ITEMS_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getBenefitItemsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/service-with-benefit-group-items`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message)
      yield put({
        type: GET_BENEFIT_ITEMS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_BENEFIT_ITEMS_LIST_ERROR,
        payload: response?.data,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFIT_ITEMS_LIST_ERROR, payload: error });
  }
}

export function* watchBenefitItemsList() {
  yield takeEvery(GET_BENEFIT_ITEMS_LIST, getBenefitItemsList);
}

function* getBenefitItemsListSaga() {
  yield all([fork(watchBenefitItemsList)]);
}

export default getBenefitItemsListSaga;
